import { render, staticRenderFns } from "./fl223-purchase-comment-edit-block.vue?vue&type=template&id=716a4c30&"
import script from "./fl223-purchase-comment-edit-block.vue?vue&type=script&lang=js&"
export * from "./fl223-purchase-comment-edit-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716a4c30')) {
      api.createRecord('716a4c30', component.options)
    } else {
      api.reload('716a4c30', component.options)
    }
    module.hot.accept("./fl223-purchase-comment-edit-block.vue?vue&type=template&id=716a4c30&", function () {
      api.rerender('716a4c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl223/partials/fl223-purchase-comment-edit-block.vue"
export default component.exports